import React from 'react';
import { motion } from 'framer-motion';
import CountryList from '../../../components/CountryList';

const DesktopCountryList = ({ countries, selectedCountry, onCountrySelect }) => (
  <div className="pointer-events-none absolute inset-0 hidden min-[1025px]:flex items-center justify-end pr-4">
    <motion.div
      initial={{ opacity: 0, x: 400 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.3 }}
      className="pointer-events-auto z-30 h-3/4 w-80 rounded-2xl border border-gray-200 bg-white shadow-2xl"
    >
      <CountryList
        countries={countries}
        selectedCountry={selectedCountry}
        onCountrySelect={onCountrySelect}
      />
    </motion.div>
  </div>
);

export default React.memo(DesktopCountryList);
